export default __webpack_public_path__ + "static/media/2_0040.bd9832d0.webp";